import { render, staticRenderFns } from "./ExclusionReasons.vue?vue&type=template&id=25b31614"
import script from "./ExclusionReasons.vue?vue&type=script&lang=js"
export * from "./ExclusionReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports